import React, { FC } from 'react';
import { Select } from 'antd';
import {
	ACC_AUDIT_ACTIONABLE_STATUSES,
	ACC_AUDIT_CHANGE_APPLY_STATUSES,
	ACC_AUDIT_KEY_DISPLAY_NAMES,
} from '../../utils/AssetCycleUtils';
import { CheckCircleFilled } from '@ant-design/icons';

interface ACCAuditStatusSelectProps {
	value: string;
	onChange: (status: string) => void;
	size?: 'small' | 'middle' | 'large';
	style?: React.CSSProperties;
	loading?: boolean;
}

const ACCAuditStatusSelect: FC<ACCAuditStatusSelectProps> = ({
	value,
	onChange,
	size = 'large',
	style,
	loading,
}) => {
	const ALL_ALLOWED_STATUSES = [
		...ACC_AUDIT_ACTIONABLE_STATUSES,
		ACC_AUDIT_CHANGE_APPLY_STATUSES.RunInProgress,
		ACC_AUDIT_CHANGE_APPLY_STATUSES.Logged,
	];
	if (!ALL_ALLOWED_STATUSES.includes(value)) {
		return null;
	}

	const displayValue = ACC_AUDIT_ACTIONABLE_STATUSES.includes(value)
		? value
		: ACC_AUDIT_CHANGE_APPLY_STATUSES.WaitingForApproval;

	return (
		<Select
			value={displayValue}
			onChange={onChange}
			style={{ minWidth: 180, textAlign: 'left', ...style }}
			size={size}
			loading={loading}
			defaultValue={ACC_AUDIT_CHANGE_APPLY_STATUSES.WaitingForApproval}
		>
			{ACC_AUDIT_ACTIONABLE_STATUSES.map((status) => (
				<Select.Option key={status} value={status}>
					{status === ACC_AUDIT_CHANGE_APPLY_STATUSES.Approved ? (
						<span>
							<CheckCircleFilled style={{ color: '#237804', marginRight: 6 }} />
							{ACC_AUDIT_KEY_DISPLAY_NAMES[status]}
						</span>
					) : (
						ACC_AUDIT_KEY_DISPLAY_NAMES[status]
					)}
				</Select.Option>
			))}
		</Select>
	);
};

export default ACCAuditStatusSelect;
